import { DOCS_URL } from "../../../config/constants.js";
import ServiceIntroText from "./ServiceIntroText.svelte";

export default {
    component: ServiceIntroText,
    name: "Service Intro Text",
    description:
        "Large introductory copy for the start of service pages. Does not appear in the in-page navigation.",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-serviceintrotext--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/text-size.svg",
    models: ["service-page"],
    inputs: [
        {
            friendlyName: "Intro copy",
            name: "content",
            type: "richText",
            required: true,
            helperText:
                "Use for the opening service page paragraph. This block does not generate a navigation item.",
        },
    ],
};
